import { useState, useCallback, useEffect, useRef } from "react";
import { motion } from "framer-motion"
import { useNavigate } from "react-router-dom";


import useMount from '../../hooks/useMount';
import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import BackButton from "../Commons/BackButton";
import productApi from "../../api/productApi";
import useLog from "../../hooks/useLog";

import { getLabel, getLanguage } from "../../tools/Dictionary";
import { IoIosArrowForward } from "react-icons/io";
import { p } from "framer-motion/client";

const TroubleshootFilter = (props) =>
{

   //Logs
  const { logPageView, logUserAction } = useLog();

  //Navigation
  const Navigate = useNavigate();

  //Props
  const IsDesktop = props.IsDesktop;
  //const Access = props.Access;
  //const setParentLoading = props.setParentLoading;

  //State
  const [form, setForm] = useState({
    search: "",
    brand: undefined,
    category: undefined,
    type: undefined,
    family: undefined
  });
  const [product, setProduct] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSearching, SetIsSearching] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  //Ref
  const isReadyToSearch = useRef(false);

  useMount(() =>
  {
    logPageView("Troubleshoot Filter Page");
    loadData();
  }, []);

  const filterProduct = useCallback(async(_form) => {

    try{
      
      SetIsSearching(true);

      


      let foundProduct = await productApi.getProductForSearch({ search: _form.search.toUpperCase() });

      if (_form.search.trim() !== "" && foundProduct.Success && foundProduct.Data.length < 20)
        logUserAction("Search product", { search: _form.search, result: foundProduct.Data.map(p => ({ code: p.code, id: p._id })) });
      else
        logUserAction("Search product", { search: _form.search, message: `Too many results or no results [${foundProduct.Success ? foundProduct.Data.length : 0}]` });


      if (foundProduct.Success)
      {
        setProduct(foundProduct.Data);
      } else
        throw new Error(foundProduct.Error.label);

      SetIsSearching(false);


    }catch(err){


      SetIsSearching(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });
     

    };

  }, [logPageView]);

  // const filterProduct = useCallback((_form) => {

  //   let currentResult = [];


  //   product.forEach(p => {


  //     p.grade = -1;

  //     if (p.code.toUpperCase() == _form.search.toUpperCase()){

  //       p.grade = 0;

  //     } else if (p.code.toUpperCase().includes(_form.search.toUpperCase())){

  //       p.grade = p.code.length - _form.search.length;

  //       if (p.grade > 10) p.grade = 10;

  //     } else if (p.brand.code.toUpperCase() == _form.search.toUpperCase() || p.brand.label[getLanguage().code].toUpperCase() == _form.search.toUpperCase()){

  //       p.grade = 20;

  //     } else if (p.productCategory.code.toUpperCase() == _form.search.toUpperCase() || p.productCategory.label[getLanguage().code].toUpperCase() == _form.search.toUpperCase())
  //     {

  //       p.grade = 20;

  //     } else if (p.productType.code.toUpperCase() == _form.search.toUpperCase() || p.productType.label[getLanguage().code].toUpperCase() == _form.search.toUpperCase())
  //     {

  //       p.grade = 20;

  //     } else if (p.productFamily.code.toUpperCase() == _form.search.toUpperCase() || p.productFamily.label[getLanguage().code].toUpperCase() == _form.search.toUpperCase())
  //     {

  //       p.grade = 20;

  //     } else if ((p.brand.code.toUpperCase() + "|" + p.productCategory.code.toUpperCase() + "|" + p.productType.code.toUpperCase() + "|" + p.productFamily.code.toUpperCase()).includes(_form.search.toUpperCase()) ||
  //               (p.brand.label[getLanguage().code].toUpperCase() + "|" + p.productCategory.label[getLanguage().code].toUpperCase() + "|" + p.productType.label[getLanguage().code].toUpperCase() 
  //               + "|" + p.productFamily.label[getLanguage().code].toUpperCase()).includes(_form.search.toUpperCase())){
  //       p.grade = 40;
  //       console.log(p);
  //     }

  //     console.log(p.grade);

  //     if (p.grade >= 0)
  //       currentResult.push(p);

  //   });

  //   currentResult.sort((a, b) => {

  //     if (a.grade > b.grade) return 1;
  //     if (b.grade < a.grade) return -1;

  //     return 0;

  //   });


  //   setResult(currentResult);



  // }, [product]);


  useEffect(() =>
  {

    if (!isReadyToSearch.current){

      isReadyToSearch.current = true;
      
      return;

    }

    // Timer to wait for 1 second before searching when changing model number.
    const timer = setTimeout(() =>
    {

      //Search in product
      filterProduct(form);
    }, 500);


    // Cleanup the timer if the component unmounts or if the input changes
    return () => clearTimeout(timer);

  }, [form, filterProduct]);

  useEffect(() => {

    if (!loading) document.getElementById("search").focus();

  }, [loading]);



  const loadData = async (_showLoading = true) =>
  {

    try
    {

      if (_showLoading)
      {
        setLoading(true);
      }

      let [searchData] = await Promise.all([
        productApi.getProductForSearch({search: ""})
      ]);


      if (searchData.Success)
      {
        setProduct(searchData.Data);
      } else
        throw new Error(searchData.Error.label);

      setLoading(false);

      

    } catch (err)
    {

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };

  const onChangeSearch = (e) =>  {

    setForm(form => ({
      ...form,
      search: e.target.value
    }));

  };

  const onClickProduct = (_product) => {

    //Navigate(`/troubleshoot/process?product=${_product._id}&process=${_product.process}`);
    Navigate(`/troubleshoot/product?product=${_product._id}`);

  };
 


  return (
    <div className="page_body_cont">
      <LoadingComponent
        display={loading}
        label={getLabel("App", "Loading")}
        isCover={false}
      />
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <ConfirmModal
        Display={confirm.Display}
        Title={confirm.Title}
        Message={confirm.Message}
        Cancel={confirm.Cancel}
        onCancel={confirm.onCancel}
        Confirm={confirm.Confirm}
        onConfirm={confirm.onConfirm}
      />
      <BackButton
        Hide={IsDesktop}
      />
      <div className="troubleshoot_title_cont" >
        <div className="troubleshoot_title_col" style={{ width: "40%", alignItems: "flex-end" }}>
        </div>
        <div className="troubleshoot_title_col troubleshoot_title_text" style={{ width: "40%" }}>{getLabel("Troubleshoot", "Troubleshooting")}</div>
        <div className="troubleshoot_title_col" style={{ width: "40%" }}></div>
      </div>
      <div className="troubleshoot_general_title">
        {getLabel("Troubleshoot", "On which product do you require assistance with troubleshooting?")}
      </div>
      <div className="troubleshoot_body_row" >
        <div className="troubleshoot_body_col_title">
          {getLabel("Troubleshoot", "Search by keywords")}
        </div>
        <div className="troubleshoot_body_search_cont">
          <div className="troubleshoot_body_col_value"></div>
          <div className="troubleshoot_body_col_value" style={{minWidth: "280px"}}>
            <input
              className="page_text_input troubleshoot_input_search"
              id={"search"}
              type="text"
              onChange={onChangeSearch}
              value={form.search}
              disabled={loading}
              placeholder={getLabel("Troubleshoot", "Model, serial number, brand, category, etc...")}
              autoFocus
            />
          </div>
          <div className="troubleshoot_body_col_value" style={{alignItems: "flex-start", justifyContent: "center", height: "100%", marginLeft: "10px"}}>
            {isSearching &&
              <div className="troubleshoot_loading_spinner"></div>
            }
          </div>
        </div>
      </div>
      <div className="troubleshoot_result_list">
        <div className="troubleshoot_result_list_cont page_noselect">
          {product.map((r, index) => (
            <motion.div key={index} className="troubleshoot_result_item"
              onClick={() => onClickProduct(r)}
              variants={{ hidden: { opacity: 0, y: -10 * index + 1 }, show: { opacity: 1, y: 0 } }}
              initial="hidden"
              animate="show"
              transition={{
                type: "tween", // Change to 'tween' for a smoother animation
                duration: 0.3, // Adjust duration as needed
                ease: "easeInOut", // Use 'easeInOut' or another easing function to remove bounce
              }}
            >
              <div className="troubleshoot_result_item_icon">
                <IoIosArrowForward />
              </div>
              <div className="troubleshoot_result_item_brand">
                {r.brand.code}
              </div>
              <div className="troubleshoot_result_item_serie">
                {r.productFamily.label[getLanguage().code || "EN" || "-"]}
              </div>
              <div className="troubleshoot_result_item_code">
                {r.code}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );

};

export default TroubleshootFilter